var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32009_278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.41961C0 0.63558 0.635581 0 1.41961 0H18.5804C19.3645 0 20.0001 0.635581 20.0001 1.41961V18.5804C20.0001 19.3644 19.3645 20 18.5804 20H1.41961C0.635582 20 0 19.3644 0 18.5804V1.41961Z",
    fill: "#0A66C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48891 6.21689C5.44712 6.21689 6.22391 5.4401 6.22391 4.48189C6.22391 3.52367 5.44712 2.74689 4.48891 2.74689C3.53069 2.74689 2.75391 3.52367 2.75391 4.48189C2.75391 5.4401 3.53069 6.21689 4.48891 6.21689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81287 7.4991H10.6883V8.81636C10.6883 8.81636 11.4686 7.25577 13.5917 7.25577C15.4856 7.25577 17.0544 8.18874 17.0544 11.0325V17.0292H14.0746V11.7591C14.0746 10.0816 13.179 9.89708 12.4966 9.89708C11.0802 9.89708 10.8378 11.1187 10.8378 11.9779V17.0292H7.81287V7.4991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97646 7.49911H6.00135V17.0292H2.97646V7.49911Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32009_278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconCircle);
export default __webpack_public_path__ + "static/media/linkedinIconCircle.29bc35b5c28daedd39c4c03786928d53.svg";
export { ForwardRef as ReactComponent };